// extracted by mini-css-extract-plugin
module.exports = {"skeletonContainer":"_f460bfa","skeletonTitleContainer":"_91c6fdc","skeletonTabContainer":"_8b097df"};